/*
src/data/OptionsManager.js
wgbh-skydiagram-testing
astro.unl.edu
2019-07-14
*/


import {SimpleStoredObject} from '../storage/SimpleStoredObject.js';
import {CallbackMakerMixin} from '../utils/CallbackMakerMixin.js';


/*

Callbacks:
	ready			- made when initialization is complete, no data,
							this callback only applies to ansychronous forms of initialization (i.e. database)
	change		- argument is a delta object as expect by the LocalComms class

*/


export class OptionsManager extends SimpleStoredObject {

	static getStoreName() {
		return 'options';
	}

	toString() {
		return 'OptionsManager';
	}

	constructor(workspace, initObj) {
		super();

		this._isReady = true;

		// initObj may be an object or undefined.
		// 	if empty or undefined 	- will use default values
		//	if has a def object			- will recreate the object
		//	if has a values object 	- will use provided values, or default values if not given
		//	if has a database property	- (asynchronous) will initialize using values from the database

		this._workspace = workspace;

		this._defaultValues = {
			allowFitToWindow: false,
			minWidth: 200,
			maxWidth: 1400,
			minHeight: 200,
			maxHeight: 1400,
		};

		if (typeof initObj === 'object') {
			if (initObj.hasOwnProperty('def')) {
				this._initWithDef(initObj.def);
			} else if (initObj.hasOwnProperty('values')) {
				this._initWithValues(initObj.values);
			} else if (initObj.hasOwnProperty('database')) {
				// useDefaults is ignored -- if the object doesn't exist, defaults will be used
				//let useDefaults = Boolean(initObj.useDefaults);
				this._isReady = false;
				this._initWithDatabase(initObj.database);
			} else {
				this._init();
			}
		} else {
			this._init();
		}

		CallbackMakerMixin.apply(this);
	}

	getIsReady() {
		return this._isReady;
	}

	_init() {
		this._initWithValues({});
	}

	_initWithValues(values) {
		// This method will initialize the class with default values that
		//	may be individually overwritten using the values object.
		// The values object must be provided, even if empty.
		// No validation is performed on the values.
		for (const key in this._defaultValues) {
			if (values.hasOwnProperty(key)) {
				this['_'+key] = values[key];
			} else {
				this['_'+key] = this._defaultValues[key];
			}
		}
	}

	_finishInitWithDatabase(dbObj) {
		if (typeof dbObj !== 'object') {
			dbObj = {};
		}
		this._initWithValues(dbObj);
		this._isReady = true;
		this.makeCallback('ready');
	}

	_initWithDef(def) {
		this._allowFitToWindow = def.allowFitToWindow;
		this._minWidth = def.minWidth;
		this._maxWidth = def.maxWidth;
		this._minHeight = def.minHeight;
		this._maxHeight = def.maxHeight;
	}

	getDef() {
		return this.getOptions();
	}

	getOptions() {
		// Returns an object containing all options.
		return {
			allowFitToWindow: this._allowFitToWindow,
			minWidth: this._minWidth,
			maxWidth: this._maxWidth,
			minHeight: this._minHeight,
			maxHeight: this._maxHeight,
		};
	}

	setOptions(arg) {
		// This method allows setting one or more options at a time using
		//	a delta object as the argument.

		let needsCallback = false;
		let delta = {};

		if (arg.hasOwnProperty('allowFitToWindow')) {
			this._allowFitToWindow = Boolean(arg.allowFitToWindow);
			delta.allowFitToWindow = this._allowFitToWindow;
			needsCallback = true;
		}

		if (needsCallback) {
			this._makeChangeCallback(delta);
		}
	}

	_makeChangeCallback(delta) {
		this._store(this.getOptions());
		this.makeCallback('change', delta);
	}

}


